let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4nvQj")).then(() => parcelRequire('3yude'));